module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel02_770_280_zh-hant-4156c2889fe59182f6d9849ae3f544c4.jpg";